// CEFR level of every Grammar Aid topic, keyed by slug. The levels follow the
// school's "Checklist de Níveis" (A1 Basic → C1 Advanced): the Foundations
// group is entirely A1 and Everyday grammar stays within A1-A2, as decided by
// the founder; the other groups are levelled topic by topic from the checklist.
// Content pools never carry levels — this map is composed into the registry.

export const GRAMMAR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1'] as const;

export type GrammarLevel = (typeof GRAMMAR_LEVELS)[number];

export const LEVEL_BY_SLUG: Record<string, GrammarLevel> = {
  // -- Foundations (all A1) --
  'glossary-of-grammar-terms': 'A1',
  'cognate-words': 'A1',
  'word-classification': 'A1',
  'question-words': 'A1',
  'verb-be-affirmative-negative': 'A1',
  'verb-be-question-form': 'A1',
  'simple-present': 'A1',
  'adverbs-of-frequency': 'A1',
  'pronouns-overview': 'A1',
  'possessive-pronouns-vs-adjectives': 'A1',
  'relative-pronouns': 'A1',
  'omission-of-that': 'A1',
  'demonstrative-adjectives': 'A1',
  'there-is-there-are': 'A1',
  'prepositions-of-place': 'A1',
  'prepositions-of-time': 'A1',
  'cardinal-numbers': 'A1',
  'ordinal-numbers-dates': 'A1',

  // -- Everyday grammar (A1 / A2) --
  'both-neither-either': 'A2',
  'present-continuous': 'A1',
  'adding-ing-gerund': 'A1',
  'simple-future': 'A1',
  'will-vs-going-to': 'A2',
  'adverbs-of-intensity': 'A1',
  'simple-past': 'A1',
  'genitive-case': 'A1',
  'english-vowel-sounds': 'A1',
  'a-or-an': 'A1',
  'talking-about-money': 'A1',
  'irregular-plural-nouns': 'A2',
  'countable-uncountable-nouns': 'A1',
  quantifiers: 'A1',
  'how-many-vs-how-much': 'A1',
  'comparatives-superlatives': 'A1',
  'correlative-comparatives': 'A2',
  'adjectives-ed-ing': 'A2',
  'attributive-adjectives': 'A1',
  'adverbs-of-degree': 'A2',
  'phrasal-verbs-general': 'A2',
  'phrasal-verbs-work': 'A2',

  // -- Modal verbs --
  'making-polite-requests': 'A1',
  'modal-verbs-overview': 'A2',
  'modals-of-ability': 'A1',
  'modals-of-past-ability': 'A1',
  'modals-of-advice': 'B1',
  'modals-of-necessity': 'B1',
  'modals-of-possibility': 'B1',
  'making-predictions': 'B1',
  'past-modal-verbs': 'B1',

  // -- Advanced tenses --
  'future-continuous': 'B1',
  'future-perfect': 'B2',
  'past-habits-used-to-would': 'B1',
  'past-continuous': 'A2',
  'present-perfect': 'A2',
  'transcendent-aspect': 'B2',
  'past-perfect': 'B1',
  'present-perfect-continuous': 'B1',
  'zero-first-conditionals': 'B1',
  'second-conditional': 'B1',
  'third-conditional': 'B2',
  'wishes-and-hopes': 'B2',
  'active-passive-voice': 'B1',
  'direct-reported-speech': 'B2',
  'academic-writing-tenses': 'C1',

  // -- Connecting ideas --
  'uses-of-rather': 'B1',
  'giving-feedback': 'B2',
  'expressing-opinions': 'B1',
  'english-global-language': 'B2',
  'sentence-connectors': 'B1',
  'connectors-of-contrast': 'B2',
  'connectors-cause-effect': 'B2',
  conjunctions: 'B1',

  // -- Fluency, pronunciation & nuance --
  'ed-pronunciation': 'A1',
  'embedded-questions': 'B2',
  'tag-questions': 'B1',
  'gerunds-infinitives': 'B1',
  'gerunds-infinitives-special-cases': 'C1',
  'to-vs-for': 'B1',
  'substitution-avoiding-repetition': 'C1',
  'one-generic-pronouns': 'C1',
  'causative-sentences': 'B2',
  'english-collocations': 'B2',
  'debating-useful-language': 'C1',
};
